import classNames from 'classnames'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import AntdConfigWrapper from 'views/AppLocals/custom/AntdConfigWrapper'
import {NullAsDefault} from 'views/Shared'
import {getTokenKey} from "../../../../../helpers/localStorage";
import DebounceSelect from "../../../../../components/LookupField/DebounceSelect";
import {API_ROOT_URL} from "../../../../../envs/_current/config";
import getTitle from "../../../../../helpers/getTitle";
import {getId} from "../../../../../apis/model/base";
import {Avatar} from "antd";
import {FaUserGraduate} from "react-icons/fa6";
import getAliasName from "../../../../../helpers/getAliasName";
import {course_getStudents_Api} from "../../../../../apis/course";


const renderOptionItem = (item) => {
    return (
        {
            id: getId(item),
            value: getId(item),
            label: (
                <div className="flex items-center gap-2">
                    <Avatar
                        size={28}
                        src={item?.avatar}
                        icon={<FaUserGraduate size={12} className="text-color-500"/>}
                        className="flex flex-center background-200"
                    />
                    <div className="font-medium text-sm text-color-000">
                        {getAliasName(item, 'patron_saint') || ''}
                        {' '}
                        {getTitle(item)}
                    </div>
                </div>
            ),
        }
    )
}

export const fetchStudents =
    ({owner_id, owner_type, student_id}) =>
        async (type, keyword) => {
            let path = API_ROOT_URL + course_getStudents_Api.path
                    .replace(":type", owner_type)
                    .replace(":id", owner_id)
                + `?keyword=${keyword}`
            if (!!student_id) path += `&with_ids=${student_id}`
            const response = await fetch(
                path,
                {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${getTokenKey()}`,
                        'Content-Type': 'application/json',
                    },
                }
            )
            const body = await response.json()
            return Array.from(_.get(body, 'data') || []).map(renderOptionItem)
        }


export const StudentResultReportFilter = ({
                                              owner_id,
                                              owner_type,
                                              className = "",
                                              value: filter = {
                                                  student_id: undefined,
                                              },
                                              onChange: setValues = NullAsDefault,
                                          }) => {
    const t = useTranslate()

    const handleChange = useCallback(
        (name, value) => {
            const params = {
                ...filter,
                [name]: value,
            }
            setValues(params)
            return params
        },
        [filter]
    )

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-3 mt-2">
            <div className="w-full flex flex-col gap-1 col-span-2">
                <div className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                    {`${t('choose students')} `}
                </div>
                <AntdConfigWrapper>
                    <DebounceSelect
                        size="large"
                        name="student_id"
                        // defaultValue={filter.student_id}
                        value={filter.student_id}
                        className={classNames('w-full', className)}
                        notFoundContent={undefined}
                        onChange={(value, option) => {
                            const next = handleChange("student_id", value)
                            setValues({
                                ...(next ?? {}),
                            })
                        }}
                        fetchOptions={fetchStudents({
                            owner_id,
                            owner_type,
                            student_id: filter.student_id
                        })}
                    />
                </AntdConfigWrapper>
            </div>
        </div>
    )
}
